export interface Template {
    id: string;
    code: string;
    name: string;
    subject: string;
    body: string;
    created_at: Date;
    updated_at: Date;
}

export enum TemplateEnum {
    PQR_TRACKING_ADVOCATE_DCF = 'PQR_TRACKING_ADVOCATE_DCF',
    PQR_TRACKING_REQUIREMENT_SFC = 'PQR_TRACKING_REQUIREMENT_SFC',
    PQR_TRACKING_PETITION_PROCESS = 'PQR_TRACKING_PETITION_PROCESS',
    PQR_TRACKING_DIRECT_PROCESS = 'PQR_TRACKING_DIRECT_PROCESS',
}
